import ListingPage from '../../components/ListingPage';
import PipelinesCards from '../../components/Pipelines/PipelineCards';
const PipelinesPage = () => {
  return (
    <ListingPage
      entityType="pipeline"
      filterBy="name"
      useStats={true}
      Cards={PipelinesCards}
      createRestrictionKey="pipelinesCreate"
    />
  );
};

export default PipelinesPage;
